import { maxBy } from "lodash";
import { Case } from "../models/generated/graphql";
import { getAssessmentDate } from "../utils/agreement-utils";
import { distinctBy } from "../utils/distinct-by";
import { getContinuousBenefits, getFormPrescriptions, getInitialResponse } from "../utils/flex-entity-utils";
import { neo4jDateToDate } from "../utils/neo4j-date-to-date";

export const getFormDatesByCases = (cases: Array<Case>, createdOn: string | null | undefined) => {
	const flexEntities = distinctBy(
		cases.flatMap((cs) => cs.flexEntitiesConnection.edges).filter(({ node: entity }) => !createdOn || entity.createdOn < createdOn),
		(edge) => edge.node.id
	);
	const startingPoint = flexEntities.find((edge) => edge.isStartingPoint);
	if (!startingPoint) {
		return {
			maxCBAssessmentDate: null,
			maxPrescriptionDate: null,
			responseAssessmentDate: null,
			requestReceiptDate: null,
		};
	}

	const continuousBenefits = getContinuousBenefits(flexEntities.map(({ node }) => node));
	const prescriptions = getFormPrescriptions(flexEntities.map(({ node }) => node));
	const initialResponse = getInitialResponse(flexEntities.map(({ node }) => node));
	const maxCBAssessmentDate = maxBy(continuousBenefits, (e) => e.benefitAssessmentDate)?.benefitAssessmentDate;
	const maxPrescriptionDate = maxBy(prescriptions, (p) => p.prescriptionDate)?.prescriptionDate;

	return {
		maxCBAssessmentDate: neo4jDateToDate(maxCBAssessmentDate),
		maxPrescriptionDate: neo4jDateToDate(maxPrescriptionDate),
		responseAssessmentDate: neo4jDateToDate(initialResponse?.responseAssessmentDate),
		startingFormAssessmentDate: getAssessmentDate(startingPoint?.node),
	};
};
